export default __webpack_public_path__ + "static/media/gallery_04.14e1a41b.jpg";